import React, { useState } from 'react';
import './ContactUs.css';

const ContactUs = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: ''
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Here you would typically handle the form submission
        console.log('Form submitted:', formData);
    };

    return (
        <div className="contact-container">
            <div className="contact-header">
                <h2>Contact Us</h2>
                <p>Get in touch with us for any inquiries or support</p>
            </div>
            
            <div className="contact-content">
                <div className="contact-form-section">
                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label htmlFor="name">Name</label>
                            <input
                                type="text"
                                id="name"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        
                        <div className="form-group">
                            <label htmlFor="email">Email</label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="phone">Phone Number</label>
                            <input
                                type="tel"
                                id="phone"
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="message">Message</label>
                            <textarea
                                id="message"
                                name="message"
                                value={formData.message}
                                onChange={handleChange}
                                required
                            ></textarea>
                        </div>

                        <button type="submit" className="submit-button">
                            Send Message
                        </button>
                    </form>
                </div>

                <div className="contact-info-section">
                    <div className="contact-info-card">
                        <h3>Visit Us</h3>
                        <p>
                            PROP NO NEW 1742,OLD 4_NEW, PLOT NO 11B, SURVAY NO 167/1,WD NO A7, KURHEAPPA LAYOUT,TREASURY COLONY, , NR SSD BAGLO<br />
                            Tal : AMRAVATI ( AMARAVATI )<br />
                            Pin : 444601
                        </p>
                        
                        <h3>Contact Information</h3>
                        <p>
                            <strong>Phone:</strong> +91 848 299 5385<br />
                            <strong>Email:</strong> dastarstrade13@gmail.com
                        </p>

                        <div className="social-links">
                            <a href="https://www.facebook.com/people/D-A-stars-International-Trade/61568409791499/" target="_blank" rel="noopener noreferrer" className="social-icon">
                                <i className="fa-brands fa-facebook-f"></i>
                            </a>
                            <a href="https://www.linkedin.com/in/deva-pundkar-2a5866334" target="_blank" rel="noopener noreferrer" className="social-icon">
                                <i className="fa-brands fa-linkedin-in"></i>
                            </a>
                            <a href="https://www.instagram.com/dastars13" target="_blank" rel="noopener noreferrer" className="social-icon">
                                <i className="fa-brands fa-instagram"></i>
                            </a>
                            <a href="http://www.youtube.com/@D-Astarsinternationaltrade-h4i" target="_blank" rel="noopener noreferrer" className="social-icon">
                                <i className="fa-brands fa-youtube"></i>
                            </a>
                            <a href="mailto:dastarstrade13@gmail.com" className="social-icon">
                                <i className="fa-solid fa-envelope"></i>
                            </a>
                            <a href="https://wa.me/8237434068" className="social-icon whatsapp">
                                <i className="fab fa-whatsapp"></i>
                            </a>
                       </div> 

                        <div className="map-container">
                            <iframe
                                title="D-Astars Healthcare Location Map"
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d..."
                                width="100%"
                                height="250"
                                style={{ border: 0 }}
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                            ></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactUs;
